import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Menu, X, LayoutDashboard, Radio, FolderKanban, Sparkles, HandCoins, UserRound, LogOut
} from 'lucide-react';
import { ChatButton } from '../chat';
import { useChatEnabled } from '../../hooks/useChatEnabled';

const CreatorNavbar = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const { chatEnabled } = useChatEnabled();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const menuItems = [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/dashboard/creator', onClick: () => navigate('/dashboard/creator') },
    { label: 'Live Campaigns', icon: Radio, path: '/dashboard/creator/live-campaigns', onClick: () => navigate('/dashboard/creator/live-campaigns') },
    { label: 'My Projects', icon: FolderKanban, path: '/dashboard/creator/projects', onClick: () => navigate('/dashboard/creator/projects') },
    { label: 'Creator Hub', icon: Sparkles, path: '/dashboard/creator/collaborator-club', onClick: () => navigate('/dashboard/creator/collaborator-club') },
    { label: 'My Sponsorships', icon: HandCoins, path: '/dashboard/creator/sponsorships', onClick: () => navigate('/dashboard/creator/sponsorships') },
    {
      label: 'My Profile',
      icon: UserRound,
      path: '/dashboard/creator/profile-manage',
      matchMode: 'startsWith',
      onClick: () => user && navigate(`/dashboard/creator/profile-manage/${user.userId}`)
    },
    { label: 'Logout', icon: LogOut, onClick: handleLogout, isLogout: true }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-collaborb-spherical-shadow bg-collaborb-inner text-white backdrop-blur-xl shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3 gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <img src="/collaborb-logo.png" alt="CollabOrb logo" className="w-10 h-10 sm:w-11 sm:h-11 rounded-2xl bg-white/10 p-2 object-contain" />
            <div className="min-w-0">
              <img src="/collaborb-text.png" alt="CollabOrb wordmark" className="w-24 h-8 sm:w-32 sm:h-9 md:w-40 md:h-10 object-contain" />
              <p className="hidden sm:block text-xs text-slate-400">Creator workspace</p>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-2 overflow-x-auto">
            {chatEnabled && <ChatButton />}
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = item.path && (
                item.matchMode === 'startsWith'
                  ? location.pathname.startsWith(item.path)
                  : location.pathname === item.path
              );

              return (
                <button
                  key={item.label}
                  className={`px-3 py-2 rounded-full text-sm transition-colors whitespace-nowrap ${
                    item.isLogout
                      ? 'text-red-200 hover:bg-red-500/20'
                      : isActive
                        ? 'bg-white text-collaborb-inner font-semibold'
                        : 'text-slate-300 hover:bg-white/10'
                  }`}
                  onClick={() => {
                    item.onClick();
                    setIsOpen(false);
                  }}
                >
                  <span className="inline-flex items-center gap-1.5">
                    {Icon && <Icon className="w-4 h-4" />}
                    {item.label}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-1 rounded-md hover:bg-white/10 transition-colors"
            >
              {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {isOpen && (
          <div className="md:hidden pb-3">
            <div className="rounded-3xl border border-white/10 bg-white/5 p-3 space-y-1">
              {menuItems.map((item) => (
                <button
                  key={item.label}
                  className={`block w-full text-left px-3 py-2 rounded-2xl text-sm transition-colors ${
                    item.isLogout ? 'text-red-200 hover:bg-red-500/20' : 'hover:bg-white/10'
                  }`}
                  onClick={() => {
                    item.onClick();
                    setIsOpen(false);
                  }}
                >
                  <span className="inline-flex items-center gap-2">
                    {item.icon && <item.icon className="w-4 h-4" />}
                    {item.label}
                  </span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default CreatorNavbar;
